.signet-switch {
  // display: inline-flex;

  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 18px;
  }

  .toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.087);
    border-radius: 34px;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 25px;
    width: 25px;
    left: 10px;
    right: -2px;
    top: 50%;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
    transform: translate(-50%, -50%);
    box-shadow: 0px 0.8947368264198303px 2.6842105388641357px 0px
        rgba(0, 0, 0, 0.12),
      0px 0.8947368264198303px 0.8947368264198303px 0px rgba(0, 0, 0, 0.14),
      0px 1.7894736528396606px 0.8947368264198303px -0.8947368264198303px rgba(0, 0, 0, 0.2);
  }

  .slider.disabled {
    cursor: not-allowed;
  }

  input:checked + .slider {
    background-color: var(--primary-light);
  }

  input:checked + .slider:before {
    transform: translate(14px, -50%);
    background-color: var(--primary-main);
  }
}
